import { createSlice, createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { nextId } from "../../utils";

const tiersAdapter = createEntityAdapter();

const initialTier = {
	id: 0,
	propertyId: 0,
	product: "",
	otherProduct: "",
	rate: "",
	arm: "",
	termBefore: "",
	termAfter: "",
	termRemaining: "",
	credit: "",
	debt: "",
	equity: ""
};

const emptyInitialState = tiersAdapter.getInitialState();
const initialState = tiersAdapter.upsertOne(emptyInitialState, initialTier);

const tiersSlice = createSlice({
	name: "tiers",
	initialState,
	reducers: {
		tierAdded(state, action) {
			const id = nextId(state.ids);
			const tier = {
				id,
				propertyId: action.payload.id,
				product: "",
				otherProduct: "",
				rate: "",
				arm: "",
				termBefore: "",
				termAfter: "",
				termRemaining: "",
				credit: "",
				debt: "",
				equity: ""
			};
			tiersAdapter.addOne(state, tier);
		},
		editTier: tiersAdapter.updateOne,
		tierDeleted(state, action) {
			tiersAdapter.removeOne(state, action.payload);
		},
		clearTiersByProperty(state, action) {
			Object.values(state.entities).forEach((tier) => {
				if(tier.propertyId === action.payload) {
					tiersAdapter.removeOne(state, tier.id);
				}
			})
		}
	},
	extraReducers: builder => {
		builder
			.addCase("calculators/loadCalculator/fulfilled", (state, action) => {
				if(action.payload.type === "mortgage") {
					tiersAdapter.setAll(state, JSON.parse(action.payload.json).calc.tiers.entities)
				}
			})
	}
})

export const {
	editTier,
	tierAdded,
	tierDeleted,
	clearTiersByProperty
} = tiersSlice.actions;

export default tiersSlice.reducer

export const { selectAll: selectTiers, selectById: selectTierById } = tiersAdapter.getSelectors(state => state.mortgage.tiers);

export const selectTiersByPropertyId = createSelector(
	selectTiers,
	(state, propertyId) => propertyId,
	(tiers, propertyId) => tiers.filter(tier => tier.propertyId === propertyId)
);
